import request from '@/utils/request'

// 获取消息推送列表
export function getProjectConfigList(data) {
  return request.get('/projectConfig/list')
}
